var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { "grid-list-xl": "", fluid: "" } },
    [
      _c(
        "v-layout",
        { attrs: { row: "", wrap: "" } },
        [
          _c(
            "v-flex",
            { attrs: { xs6: "", "offset-xs2": "" } },
            [
              _c(
                "v-card",
                [
                  _c("v-data-table", {
                    attrs: {
                      headers: _vm.headers,
                      items: _vm.orders,
                      pagination: _vm.pagination,
                      "total-items": _vm.totalOrders
                    },
                    on: {
                      "update:pagination": function($event) {
                        _vm.pagination = $event
                      }
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "items",
                        fn: function(props) {
                          return [
                            _c("td", [_vm._v(_vm._s(props.item.orderCode))]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                _vm._s(props.item.customerID.firstName) +
                                  " " +
                                  _vm._s(props.item.customerID.lastName)
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", { attrs: { align: "right" } }, [
                              _vm._v(
                                "$" +
                                  _vm._s(
                                    (
                                      props.item.subTotal +
                                      props.item.shipping +
                                      props.item.insurance +
                                      props.item.install +
                                      props.item.measure -
                                      props.item.discount
                                    ).toFixed(2)
                                  )
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", [_vm._v(_vm._s(props.item.date))]),
                            _vm._v(" "),
                            _c("td"),
                            _vm._v(" "),
                            _c(
                              "td",
                              { attrs: { align: "center" } },
                              [
                                _c(
                                  "v-btn",
                                  {
                                    attrs: { small: "" },
                                    on: {
                                      click: function($event) {
                                        return _vm.recoverToQuote(
                                          props.item._id
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v("Quote")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-btn",
                                  {
                                    attrs: { small: "" },
                                    on: {
                                      click: function($event) {
                                        return _vm.recoverToOrder(
                                          props.item._id
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v("Order")]
                                )
                              ],
                              1
                            )
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { xs12: "", md2: "", left: "", "pl-4": "" } },
            [
              _c(
                "v-card",
                [
                  _c("v-card-title", [_c("h4", [_vm._v("Filter")])]),
                  _vm._v(" "),
                  _c("v-divider"),
                  _vm._v(" "),
                  _c(
                    "v-card-text",
                    [
                      _c("v-select", {
                        attrs: {
                          items: _vm.availableUsers,
                          label: "Filter Users",
                          "item-value": "id",
                          "item-text": "firstName",
                          multiple: "",
                          "menu-props": "bottom"
                        },
                        on: {
                          input: function($event) {
                            return _vm.searchQuotes()
                          }
                        },
                        model: {
                          value: _vm.enabledUsers,
                          callback: function($$v) {
                            _vm.enabledUsers = $$v
                          },
                          expression: "enabledUsers"
                        }
                      }),
                      _vm._v(" "),
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c("v-text-field", {
                        attrs: {
                          "append-icon": "search",
                          label: "Search",
                          "single-line": "",
                          "hide-details": ""
                        },
                        on: {
                          change: function($event) {
                            return _vm.searchQuotes()
                          }
                        },
                        model: {
                          value: _vm.search,
                          callback: function($$v) {
                            _vm.search = $$v
                          },
                          expression: "search"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-snackbar",
        {
          attrs: { dark: "", top: "", timeout: 3000 },
          model: {
            value: _vm.snackbar,
            callback: function($$v) {
              _vm.snackbar = $$v
            },
            expression: "snackbar"
          }
        },
        [
          _vm._v("\n    " + _vm._s(_vm.popupText) + "\n    "),
          _c(
            "v-btn",
            {
              attrs: { dark: "", flat: "" },
              on: {
                click: function($event) {
                  _vm.snackbar = false
                }
              }
            },
            [_vm._v("Close")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-56a83c7c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56a83c7c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Archive.vue
// module id = null
// module chunks = 